import { getInfo } from '@/api/login';

const user = {
  state: {
    name: '',
    avatar: '',
    token: '',
    department: '',
  },
  mutations: {
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_DEPARTMENT: (state, department) => {
      state.department = department;
    },
  },
  actions: {
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo('123456789').then((response) => {
          const { name, avator, department } = response;
          commit('SET_NAME', name);
          commit('SET_AVATAR', avator);
          commit('SET_DEPARTMENT', department);
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },
  },
};

export default user;
